import { Rank } from '@domain/insights/models/Rank';
import { WeeklySearchVolume } from '@domain/insights/models/SearchTrend';
import { Search } from '@domain/insights/models/Search';
import { DailyProductRank } from '@domain/insights/models/DailyProductRank';
import { RankDTO, WeeklySearchVolumeDTO, SearchDTO, DailyProductRankDTO } from '../dto/InsightsDTO';
import { ConnectorMapper } from '@infrastructure/connection/mappers/ConnectorMapper';
import { ProductListingMapper } from '@infrastructure/product/mappers/ProductListingMapper';
import { ForecastModel } from '@domain/forecast/models/ForecastParameters';
import { SeasonalityMode } from '@domain/forecast/models/ForecastParameters';
import { TrendMode } from '@domain/forecast/models/ForecastParameters';


export class InsightsMapper {
  static rankToModel(dto: RankDTO): Rank {
    return {
      id: dto.id,
      searchTerm: dto.searchTerm,
      search: InsightsMapper.searchToModel(dto.search),
      listing: ProductListingMapper.toModel(dto.listing),
      marketplaceConnectionId: dto.marketplaceConnectionId,
      wasSponsored: dto.wasSponsored,
      type: dto.type,
      createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
      updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : undefined,
      dailyProductRanks: dto.dailyProductRanks ? dto.dailyProductRanks.map(InsightsMapper.dailyProductRankToModel) : undefined,
    };
  }

  static searchToModel(dto: SearchDTO): Search {
    return {
      searchTerm: dto.searchTerm,
      connectorType: dto.connectorType,
      connector: dto.connector ? ConnectorMapper.toModel(dto.connector) : undefined,
      forecastGrade: dto.forecastGrade,
      forecastParameters: dto.forecastParameters ? {
        model: dto.forecastParameters.model as ForecastModel,
        seasonality_mode: dto.forecastParameters.seasonality_mode as SeasonalityMode,
        growth: dto.forecastParameters.trend_mode as TrendMode,
        search_term_regressor: dto.forecastParameters.search_term_regressor,
      } : undefined,
      createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
      updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : undefined,
    };
  }

  static searchTrendToModel(dto: WeeklySearchVolumeDTO): WeeklySearchVolume {
    return {
      searchTerm: dto.searchTerm,
      week: dto.week,
      year: dto.year,
      countryCode: dto.countryCode,
      volume: dto.volume,
      connectorType: dto.connectorType,
      searchTermEntity: InsightsMapper.searchToModel(dto.searchTermEntity),
      createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
      updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : undefined,
    };
  }

  static dailyProductRankToModel(dto: DailyProductRankDTO): DailyProductRank {
    return {
      rankId: dto.rankId,
      date: new Date(dto.date),
      rank: dto.rank,
      impressions: dto.impressions,
      productRank: dto.productRank ? InsightsMapper.rankToModel(dto.productRank) : undefined,
      createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
      updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : undefined,
    };
  }
} 